module.exports = __webpack_public_path__ + "img/tags-icon.a4f13aca.svg";